import { useNavigate } from "react-router-dom";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import { Registration_Lottie } from "../../../lotties/registration-lottie/Registration_Lottie";

const Owner_Success_Page = () => {
  const navigate = useNavigate();
  return (
    <section className="success_page step1_wrapper step3_wrapper owner_success_page">
      <Form_Header
        title="Upload Gym Images"
        subtitle=""
        step={6}
        totalSteps={6}
      />

      <div className="container">
        <div className="success_lottie_holder">
          <div className="success_lottie_text_holder">
            <h2 className="registration">Registration Done Successfully!</h2>
            <p className="success_text">
              We will notify you within 24 hours via Email & Message with
              Confirmation link or, if arises any query.
            </p>
            <p className="success_subtext">Have a Fine Time Ahead!</p>
          </div>
          <div className="lottie_holder">
            <Registration_Lottie />
          </div>
        </div>

        <div className="form_btn_holder">
          <Common_Btn btnText="Got it" onClick={() => navigate("/home")} />
        </div>
      </div>
    </section>
  );
};

export default Owner_Success_Page;
